<div class="p-5">
  <div class="flex items-center gap-2 mb-3">
    <mat-icon style="color: #6366f1;">policy</mat-icon>
    <h2 style="font-size: 1.1rem; font-weight: 700; color: #111827; margin: 0;">Consultar liquidación BCV</h2>
  </div>
  <p style="font-size: 0.78rem; color: #6b7280; margin-bottom: 14px;">
    Consulta el estado real de una transacción interbancaria en el BCV. Útil cuando una TX quedó en <code>PENDING_BCV</code>.
  </p>

  <form [formGroup]="form" (ngSubmit)="consultar()" class="grid grid-cols-1 sm:grid-cols-2 gap-3">
    <mat-form-field appearance="outline" class="modern-field sm:col-span-2">
      <mat-label>RIF/CI ordenante (12 chars)</mat-label>
      <input matInput formControlName="id" placeholder="J00507986268">
    </mat-form-field>
    <mat-form-field appearance="outline" class="modern-field sm:col-span-2">
      <mat-label>Cuenta origen (20 dígitos)</mat-label>
      <input matInput formControlName="cuenta" placeholder="01380003150030180510">
    </mat-form-field>
    <mat-form-field appearance="outline" class="modern-field">
      <mat-label>Referencia (8 dígitos)</mat-label>
      <input matInput formControlName="referencia" placeholder="87646548">
    </mat-form-field>
    <mat-form-field appearance="outline" class="modern-field">
      <mat-label>Monto</mat-label>
      <input matInput formControlName="monto" placeholder="1000.00">
    </mat-form-field>
    <mat-form-field appearance="outline" class="modern-field">
      <mat-label>Fecha de la operación</mat-label>
      <input matInput type="date" (change)="onFechaPickerChange($event)">
    </mat-form-field>
    <mat-form-field appearance="outline" class="modern-field">
      <mat-label>Fecha YYMMDD (auto)</mat-label>
      <input matInput formControlName="fecha" placeholder="260506" maxlength="6">
    </mat-form-field>

    <div class="sm:col-span-2 flex justify-end gap-2 mt-2">
      <button type="button" (click)="close()"
        style="padding: 8px 20px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer;">
        Cerrar
      </button>
      <button type="submit" [disabled]="loading"
        [style.opacity]="loading ? '0.5' : '1'"
        style="padding: 8px 24px; background: #6366f1; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; display: inline-flex; align-items: center; gap: 6px;">
        <mat-spinner *ngIf="loading" diameter="14"></mat-spinner>
        <mat-icon *ngIf="!loading" style="font-size: 16px; width: 16px; height: 16px;">search</mat-icon>
        Consultar
      </button>
    </div>
  </form>

  <div *ngIf="result" class="mt-4 p-3 rounded-lg border"
    [style.background]="result.header?.codigoRespuesta === '0000' ? '#f0fdf4' : (result.header?.codigoRespuesta === '9999' ? '#fef9c3' : '#fef2f2')"
    [style.border-color]="result.header?.codigoRespuesta === '0000' ? '#bbf7d0' : (result.header?.codigoRespuesta === '9999' ? '#fde68a' : '#fecaca')">
    <div class="font-bold mb-2">{{ codigoLabel }}</div>
    <div class="text-xs space-y-1">
      <div><strong>Código:</strong> {{ result.header?.codigoRespuesta }}</div>
      <div><strong>Cliente:</strong> {{ result.header?.descripcionCliente }}</div>
      <div><strong>Sistema:</strong> {{ result.header?.descripcionSistema }}</div>
      <div><strong>Fecha:</strong> {{ result.header?.fechaHora }}</div>
    </div>
  </div>

  <div *ngIf="error" class="mt-4 p-3 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm">
    ✗ {{ error }}
  </div>
</div>
